import { render, staticRenderFns } from "./Registro_detalles.vue?vue&type=template&id=b9722cd4"
import script from "./Registro_detalles.vue?vue&type=script&lang=js"
export * from "./Registro_detalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports